/* =========================================================
   WWC Testimonials Slider
   Requires Swiper already loaded in theme.liquid
========================================================= */

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-wwc-testimonials]';
  var SLIDER_SELECTOR = '[data-wwc-testimonials-slider]';

  function initAllTestimonials() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (section) {
      if (section.dataset.wwcTestimonialsInit === '1') return;

      var slider = section.querySelector(SLIDER_SELECTOR);
      if (!slider) return;

      if (!window.Swiper) {
        section.dataset.wwcTestimonialsWaiting = '1';
        return;
      }

      section.dataset.wwcTestimonialsInit = '1';
      initSlider(section, slider);
    });
  }

  function initSlider(section, slider) {
    var next = section.querySelector('[data-wwc-testimonials-next]');
    var prev = section.querySelector('[data-wwc-testimonials-prev]');

    var gap = parseInt(slider.dataset.gap || '24', 10);
    var gapMobile = parseInt(slider.dataset.gapMobile || '16', 10);
    var view = parseFloat(slider.dataset.view || '3');
    var viewMobile = parseFloat(slider.dataset.viewMobile || '1.15');

    slider.classList.remove('is-preview');

    if (slider.wwcSwiper && typeof slider.wwcSwiper.destroy === 'function') {
      slider.wwcSwiper.destroy(true, true);
    }

    slider.wwcSwiper = new Swiper(slider, {
      speed: 350,
      watchOverflow: true,
      grabCursor: true,
      slidesPerView: viewMobile,
      spaceBetween: gapMobile,
      navigation: {
        nextEl: next,
        prevEl: prev
      },
      breakpoints: {
        768: {
          slidesPerView: Math.min(view, 3),
          spaceBetween: gap
        },
        1024: {
          slidesPerView: view,
          spaceBetween: gap
        }
      }
    });
  }

  function waitForSwiperAndInit() {
    initAllTestimonials();

    if (window.Swiper) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;

      initAllTestimonials();

      if (window.Swiper || tries >= 40) {
        window.clearInterval(timer);
      }
    }, 125);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiperAndInit);
  } else {
    waitForSwiperAndInit();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(waitForSwiperAndInit, 50);
  });
})();